export const getServiceName = (state) =>{
    let serviceName =  state.hotelQrCode > 0 ? `hotel` : state.qrPickup > 0 ? `pickUp` : state.qrTable > 0 ? `dineIn` : `menu`
    return serviceName;
}